import React from "react";
import { Box } from "@mui/material";
import { tokens } from "../../utils/figmaTokens";

const TONES = {
  success: tokens.success,
  warning: tokens.warning,
  error: tokens.error,
  info: tokens.info,
  default: tokens.neutral,
};

// A session status pill (Session status dictionary 10554:3): the tone's fill and border and
// a 6 px dot. `color` is the MUI colour name sessionStatusChip returns (047 D15).
const StatusChip = ({ label, color = "default" }) => {
  const tone = TONES[color] || TONES.default;
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        px: "8px",
        py: "3px",
        borderRadius: "9999px",
        border: `1px solid ${tone.border}`,
        bgcolor: tone.bg,
        color: tone.ink,
        fontSize: 12,
        lineHeight: "16px",
        fontWeight: 500,
        letterSpacing: "0.2px",
        whiteSpace: "nowrap",
      }}
    >
      <Box component="span" aria-hidden sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: tone.main, flexShrink: 0 }} />
      {label}
    </Box>
  );
};

export default StatusChip;
